export { EmissionsIcon } from "./emissions";
